<template>
  <div class="list-table-header">
    {{ scope.row.finishedTime ? scope.row.finishedTime : '- -' }}
  </div>
</template>
<script>
export default {
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>
